import { t } from "i18next";

export type TCountries = {
    name: string;
    flag: string;
    code: CountryCode;
    silent?: boolean;
};
export type CountryCode = (typeof countries)[number]["code"];

const countries = [
    { name: () => t("Countries.Afghanistan"), flag: "🇦🇫", code: "AF" },
    { name: () => t("Countries.ÅlandIslands"), flag: "🇦🇽", code: "AX" },
    { name: () => t("Countries.Albania"), flag: "🇦🇱", code: "AL" },
    { name: () => t("Countries.Algeria"), flag: "🇩🇿", code: "DZ" },
    { name: () => t("Countries.AmericanSamoa"), flag: "🇦🇸", code: "AS" },
    { name: () => t("Countries.Andorra"), flag: "🇦🇩", code: "AD" },
    { name: () => t("Countries.Angola"), flag: "🇦🇴", code: "AO" },
    { name: () => t("Countries.Anguilla"), flag: "🇦🇮", code: "AI" },
    { name: () => t("Countries.Antarctica"), flag: "🇦🇶", code: "AQ" },
    { name: () => t("Countries.AntiguaBarbuda"), flag: "🇦🇬", code: "AG" },
    { name: () => t("Countries.Argentina"), flag: "🇦🇷", code: "AR" },
    { name: () => t("Countries.Armenia"), flag: "🇦🇲", code: "AM" },
    { name: () => t("Countries.Aruba"), flag: "🇦🇼", code: "AW" },
    { name: () => t("Countries.Australia"), flag: "🇦🇺", code: "AU" },
    { name: () => t("Countries.Austria"), flag: "🇦🇹", code: "AT" },
    { name: () => t("Countries.Azerbaijan"), flag: "🇦🇿", code: "AZ" },
    { name: () => t("Countries.Bahamas"), flag: "🇧🇸", code: "BS" },
    { name: () => t("Countries.Bahrain"), flag: "🇧🇭", code: "BH" },
    { name: () => t("Countries.Bangladesh"), flag: "🇧🇩", code: "BD" },
    { name: () => t("Countries.Barbados"), flag: "🇧🇧", code: "BB" },
    { name: () => t("Countries.Belarus"), flag: "🇧🇾", code: "BY" },
    { name: () => t("Countries.Belgium"), flag: "🇧🇪", code: "BE" },
    { name: () => t("Countries.Belize"), flag: "🇧🇿", code: "BZ" },
    { name: () => t("Countries.Benin"), flag: "🇧🇯", code: "BJ" },
    { name: () => t("Countries.Bermuda"), flag: "🇧🇲", code: "BM" },
    { name: () => t("Countries.Bhutan"), flag: "🇧🇹", code: "BT" },
    { name: () => t("Countries.Bolivia"), flag: "🇧🇴", code: "BO" },
    { name: () => t("Countries.BosniaHerzegovina"), flag: "🇧🇦", code: "BA" },
    { name: () => t("Countries.Botswana"), flag: "🇧🇼", code: "BW" },
    { name: () => t("Countries.BouvetIsland"), flag: "🇧🇻", code: "BV" },
    { name: () => t("Countries.Brazil"), flag: "🇧🇷", code: "BR" },
    { name: () => t("Countries.BritishIndianOceanTerritory"), flag: "🇮🇴", code: "IO" },
    { name: () => t("Countries.VirginIslandsBritish"), flag: "🇻🇬", code: "VG" },
    { name: () => t("Countries.BruneiDarussalam"), flag: "🇧🇳", code: "BN" },
    { name: () => t("Countries.Bulgaria"), flag: "🇧🇬", code: "BG" },
    { name: () => t("Countries.BurkinaFaso"), flag: "🇧🇫", code: "BF" },
    { name: () => t("Countries.Burundi"), flag: "🇧🇮", code: "BI" },
    { name: () => t("Countries.Cambodia"), flag: "🇰🇭", code: "KH" },
    { name: () => t("Countries.Cameroon"), flag: "🇨🇲", code: "CM" },
    { name: () => t("Countries.Canada"), flag: "🇨🇦", code: "CA" },
    { name: () => t("Countries.CaboVerde"), flag: "🇨🇻", code: "CV" },
    { name: () => t("Countries.CaymanIslands"), flag: "🇰🇾", code: "KY" },
    { name: () => t("Countries.CentralAfricanRepublic"), flag: "🇨🇫", code: "CF" },
    { name: () => t("Countries.Chad"), flag: "🇹🇩", code: "TD" },
    { name: () => t("Countries.Chile"), flag: "🇨🇱", code: "CL" },
    { name: () => t("Countries.China"), flag: "🇨🇳", code: "CN" },
    { name: () => t("Countries.ChristmasIsland"), flag: "🇨🇽", code: "CX" },
    { name: () => t("Countries.CocosIslands"), flag: "🇨🇨", code: "CC" },
    { name: () => t("Countries.Colombia"), flag: "🇨🇴", code: "CO" },
    { name: () => t("Countries.Comoros"), flag: "🇰🇲", code: "KM" },
    { name: () => t("Countries.Congo"), flag: "🇨🇬", code: "CG" },
    { name: () => t("Countries.CongoDemocraticRepublic"), flag: "🇨🇩", code: "CD" },
    { name: () => "REPL.DEM.DU CONGO", flag: "🇨🇩", code: "CD", silent: true }, // Very specific to make R&W experience smooth
    { name: () => "REPUBLIQUE DEM. DU CONGO", flag: "🇨🇩", code: "CD", silent: true }, // Very specific to make R&W experience smooth
    { name: () => t("Countries.CookIslands"), flag: "🇨🇰", code: "CK" },
    { name: () => t("Countries.CostaRica"), flag: "🇨🇷", code: "CR" },
    { name: () => t("Countries.IvoryCoast"), flag: "🇨🇮", code: "CI" },
    { name: () => t("Countries.Croatia"), flag: "🇭🇷", code: "HR" },
    { name: () => t("Countries.Cuba"), flag: "🇨🇺", code: "CU" },
    { name: () => t("Countries.Curaçao"), flag: "🇨🇼", code: "CW" },
    { name: () => t("Countries.Cyprus"), flag: "🇨🇾", code: "CY" },
    { name: () => t("Countries.Czechia"), flag: "🇨🇿", code: "CZ" },
    { name: () => "TCHEQUE, REPUBLIQUE", flag: "🇨🇿", code: "CZ", silent: true },
    { name: () => t("Countries.Denmark"), flag: "🇩🇰", code: "DK" },
    { name: () => t("Countries.Djibouti"), flag: "🇩🇯", code: "DJ" },
    { name: () => t("Countries.Dominica"), flag: "🇩🇲", code: "DM" },
    { name: () => t("Countries.DominicanRepublic"), flag: "🇩🇴", code: "DO" },
    { name: () => t("Countries.Ecuador"), flag: "🇪🇨", code: "EC" },
    { name: () => t("Countries.Egypt"), flag: "🇪🇬", code: "EG" },
    { name: () => t("Countries.ElSalvador"), flag: "🇸🇻", code: "SV" },
    { name: () => t("Countries.EquatorialGuinea"), flag: "🇬🇶", code: "GQ" },
    { name: () => t("Countries.Eritrea"), flag: "🇪🇷", code: "ER" },
    { name: () => t("Countries.Estonia"), flag: "🇪🇪", code: "EE" },
    { name: () => t("Countries.Ethiopia"), flag: "🇪🇹", code: "ET" },
    { name: () => t("Countries.FalklandIslands"), flag: "🇫🇰", code: "FK" },
    { name: () => t("Countries.FaroeIslands"), flag: "🇫🇴", code: "FO" },
    { name: () => t("Countries.Fiji"), flag: "🇫🇯", code: "FJ" },
    { name: () => t("Countries.Finland"), flag: "🇫🇮", code: "FI" },
    { name: () => t("Countries.France"), flag: "🇫🇷", code: "FR" },
    { name: () => t("Countries.FrenchPolynesia"), flag: "🇵🇫", code: "PF" },
    { name: () => "POLYNESIEFRANCAISE", flag: "🇵🇫", code: "PF", silent: true },
    { name: () => t("Countries.Georgia"), flag: "🇬🇪", code: "GE" },
    { name: () => t("Countries.Germany"), flag: "🇩🇪", code: "DE" },
    { name: () => t("Countries.Ghana"), flag: "🇬🇭", code: "GH" },
    { name: () => t("Countries.Gibraltar"), flag: "🇬🇮", code: "GI" },
    { name: () => t("Countries.Greece"), flag: "🇬🇷", code: "GR" },
    { name: () => t("Countries.Greenland"), flag: "🇬🇱", code: "GL" },
    { name: () => t("Countries.Grenada"), flag: "🇬🇩", code: "GD" },
    { name: () => t("Countries.Guadeloupe"), flag: "🇬🇵", code: "GP" },
    { name: () => t("Countries.Guam"), flag: "🇬🇺", code: "GU" },
    { name: () => t("Countries.Guatemala"), flag: "🇬🇹", code: "GT" },
    { name: () => t("Countries.Guernsey"), flag: "🇬🇬", code: "GG" },
    { name: () => t("Countries.Guinea"), flag: "🇬🇳", code: "GN" },
    { name: () => t("Countries.GuineaBissau"), flag: "🇬🇼", code: "GW" },
    { name: () => t("Countries.Guyana"), flag: "🇬🇾", code: "GY" },
    { name: () => t("Countries.FrenchGuiana"), flag: "🇬🇫", code: "GF" },
    { name: () => "GUYANEFRANCAISE", flag: "🇬🇫", code: "GF", silent: true },
    { name: () => t("Countries.Haiti"), flag: "🇭🇹", code: "HT" },
    { name: () => t("Countries.HeardIsland_and_McDonaldIslands"), flag: "🇭🇲", code: "HM" },
    { name: () => t("Countries.HolySee"), flag: "🇻🇦", code: "VA" },
    { name: () => t("Countries.Honduras"), flag: "🇭🇳", code: "HN" },
    { name: () => t("Countries.HongKong"), flag: "🇭🇰", code: "HK" },
    { name: () => t("Countries.Hungary"), flag: "🇭🇺", code: "HU" },
    { name: () => t("Countries.Iceland"), flag: "🇮🇸", code: "IS" },
    { name: () => t("Countries.India"), flag: "🇮🇳", code: "IN" },
    { name: () => t("Countries.Indonesia"), flag: "🇮🇩", code: "ID" },
    { name: () => t("Countries.Iran"), flag: "🇮🇷", code: "IR" },
    { name: () => t("Countries.Iraq"), flag: "🇮🇶", code: "IQ" },
    { name: () => t("Countries.Ireland"), flag: "🇮🇪", code: "IE" },
    { name: () => t("Countries.IsleofMan"), flag: "🇮🇲", code: "IM" },
    { name: () => t("Countries.Israel"), flag: "🇮🇱", code: "IL" },
    { name: () => t("Countries.Italy"), flag: "🇮🇹", code: "IT" },
    { name: () => "Italy", flag: "🇮🇹", code: "IT", silent: true },
    { name: () => t("Countries.Jamaica"), flag: "🇯🇲", code: "JM" },
    { name: () => t("Countries.Japan"), flag: "🇯🇵", code: "JP" },
    { name: () => t("Countries.Jersey"), flag: "🇯🇪", code: "JE" },
    { name: () => t("Countries.Jordan"), flag: "🇯🇴", code: "JO" },
    { name: () => t("Countries.Kazakhstan"), flag: "🇰🇿", code: "KZ" },
    { name: () => t("Countries.Kenya"), flag: "🇰🇪", code: "KE" },
    { name: () => t("Countries.Kiribati"), flag: "🇰🇮", code: "KI" },
    { name: () => t("Countries.KoreaNorth"), flag: "🇰🇵", code: "KP" },
    { name: () => t("Countries.KoreaSouth"), flag: "🇰🇷", code: "KR" },
    { name: () => t("Countries.KoreaRepublic"), flag: "🇰🇷", code: "KR", silent: true },
    { name: () => t("Countries.Kuwait"), flag: "🇰🇼", code: "KW" },
    { name: () => t("Countries.Kyrgyzstan"), flag: "🇰🇬", code: "KG" },
    { name: () => t("Countries.Lao"), flag: "🇱🇦", code: "LA" },
    { name: () => t("Countries.Latvia"), flag: "🇱🇻", code: "LV" },
    { name: () => t("Countries.Lebanon"), flag: "🇱🇧", code: "LB" },
    { name: () => t("Countries.Lesotho"), flag: "🇱🇸", code: "LS" },
    { name: () => t("Countries.Liberia"), flag: "🇱🇷", code: "LR" },
    { name: () => t("Countries.Libya"), flag: "🇱🇾", code: "LY" },
    { name: () => t("Countries.Liechtenstein"), flag: "🇱🇮", code: "LI" },
    { name: () => t("Countries.Lithuania"), flag: "🇱🇹", code: "LT" },
    { name: () => t("Countries.Luxembourg"), flag: "🇱🇺", code: "LU" },
    { name: () => t("Countries.Macao"), flag: "🇲🇴", code: "MO" },
    { name: () => t("Countries.NorthMacedonia"), flag: "🇲🇰", code: "MK" },
    { name: () => t("Countries.Madagascar"), flag: "🇲🇬", code: "MG" },
    { name: () => t("Countries.Malawi"), flag: "🇲🇼", code: "MW" },
    { name: () => t("Countries.Malaysia"), flag: "🇲🇾", code: "MY" },
    { name: () => t("Countries.Maldives"), flag: "🇲🇻", code: "MV" },
    { name: () => t("Countries.Mali"), flag: "🇲🇱", code: "ML" },
    { name: () => t("Countries.Malta"), flag: "🇲🇹", code: "MT" },
    { name: () => t("Countries.MarshallIslands"), flag: "🇲🇭", code: "MH" },
    { name: () => t("Countries.Martinique"), flag: "🇲🇶", code: "MQ" },
    { name: () => t("Countries.Mauritania"), flag: "🇲🇷", code: "MR" },
    { name: () => t("Countries.Mauritius"), flag: "🇲🇺", code: "MU" },
    { name: () => t("Countries.Mayotte"), flag: "🇾🇹", code: "YT" },
    { name: () => t("Countries.Mexico"), flag: "🇲🇽", code: "MX" },
    { name: () => "Mexico", flag: "🇲🇽", code: "MX", silent: true },
    { name: () => t("Countries.Micronesia"), flag: "🇫🇲", code: "FM" },
    { name: () => t("Countries.Moldova"), flag: "🇲🇩", code: "MD" },
    { name: () => t("Countries.Monaco"), flag: "🇲🇨", code: "MC" },
    { name: () => t("Countries.Mongolia"), flag: "🇲🇳", code: "MN" },
    { name: () => t("Countries.Montenegro"), flag: "🇲🇪", code: "ME" },
    { name: () => t("Countries.Montserrat"), flag: "🇲🇸", code: "MS" },
    { name: () => t("Countries.Morocco"), flag: "🇲🇦", code: "MA" },
    { name: () => t("Countries.Mozambique"), flag: "🇲🇿", code: "MZ" },
    { name: () => t("Countries.Myanmar"), flag: "🇲🇲", code: "MM" },
    { name: () => t("Countries.Namibia"), flag: "🇳🇦", code: "NA" },
    { name: () => t("Countries.Nauru"), flag: "🇳🇷", code: "NR" },
    { name: () => t("Countries.Nepal"), flag: "🇳🇵", code: "NP" },
    { name: () => t("Countries.Netherlands"), flag: "🇳🇱", code: "NL" },
    { name: () => t("Countries.NewCaledonia"), flag: "🇳🇨", code: "NC" },
    { name: () => "NOUVELLECALEDONIE", flag: "🇳🇨", code: "NC", silent: true },
    { name: () => t("Countries.NewZealand"), flag: "🇳🇿", code: "NZ" },
    { name: () => t("Countries.Nicaragua"), flag: "🇳🇮", code: "NI" },
    { name: () => t("Countries.Niger"), flag: "🇳🇪", code: "NE" },
    { name: () => t("Countries.Nigeria"), flag: "🇳🇬", code: "NG" },
    { name: () => t("Countries.Niue"), flag: "🇳🇺", code: "NU" },
    { name: () => t("Countries.NorfolkIsland"), flag: "🇳🇫", code: "NF" },
    { name: () => t("Countries.NorthernMarianaIslands"), flag: "🇲🇵", code: "MP" },
    { name: () => t("Countries.Norway"), flag: "🇳🇴", code: "NO" },
    { name: () => t("Countries.Oman"), flag: "🇴🇲", code: "OM" },
    { name: () => t("Countries.Pakistan"), flag: "🇵🇰", code: "PK" },
    { name: () => t("Countries.Palau"), flag: "🇵🇼", code: "PW" },
    { name: () => t("Countries.Palestine"), flag: "🇵🇸", code: "PS" },
    { name: () => t("Countries.Panama"), flag: "🇵🇦", code: "PA" },
    { name: () => t("Countries.PapuaNewGuinea"), flag: "🇵🇬", code: "PG" },
    { name: () => t("Countries.Paraguay"), flag: "🇵🇾", code: "PY" },
    { name: () => t("Countries.Peru"), flag: "🇵🇪", code: "PE" },
    { name: () => t("Countries.Philippines"), flag: "🇵🇭", code: "PH" },
    { name: () => t("Countries.Pitcairn"), flag: "🇵🇳", code: "PN" },
    { name: () => t("Countries.Poland"), flag: "🇵🇱", code: "PL" },
    { name: () => t("Countries.Portugal"), flag: "🇵🇹", code: "PT" },
    { name: () => t("Countries.PuertoRico"), flag: "🇵🇷", code: "PR" },
    { name: () => t("Countries.Qatar"), flag: "🇶🇦", code: "QA" },
    { name: () => t("Countries.Réunion"), flag: "🇷🇪", code: "RE" },
    { name: () => t("Countries.Romania"), flag: "🇷🇴", code: "RO" },
    { name: () => t("Countries.RussianFederation"), flag: "🇷🇺", code: "RU" },
    { name: () => t("Countries.Rwanda"), flag: "🇷🇼", code: "RW" },
    { name: () => t("Countries.SaintBarthélemy"), flag: "🇧🇱", code: "BL" },
    { name: () => t("Countries.SaintHelena"), flag: "🇸🇭", code: "SH" },
    { name: () => t("Countries.SaintKitts"), flag: "🇰🇳", code: "KN" },
    { name: () => t("Countries.SaintLucia"), flag: "🇱🇨", code: "LC" },
    { name: () => t("Countries.SaintMartin"), flag: "🇲🇫", code: "MF" },
    { name: () => t("Countries.SaintPierreAndMiquelon"), flag: "🇵🇲", code: "PM" },
    { name: () => "ST PIERRE & MIQUELON", flag: "🇵🇲", code: "PM", silent: true }, // R&W smooth experience
    { name: () => "STPIERREETMIQUELON", flag: "🇵🇲", code: "PM", silent: true }, // R&W smooth experience
    { name: () => t("Countries.SaintVincent_and_theGrenadines"), flag: "🇻🇨", code: "VC" },
    { name: () => t("Countries.Samoa"), flag: "🇼🇸", code: "WS" },
    { name: () => t("Countries.SanMarino"), flag: "🇸🇲", code: "SM" },
    { name: () => t("Countries.SaoTome"), flag: "🇸🇹", code: "ST" },
    { name: () => t("Countries.SaudiArabia"), flag: "🇸🇦", code: "SA" },
    { name: () => t("Countries.Senegal"), flag: "🇸🇳", code: "SN" },
    { name: () => t("Countries.Serbia"), flag: "🇷🇸", code: "RS" },
    { name: () => t("Countries.Seychelles"), flag: "🇸🇨", code: "SC" },
    { name: () => t("Countries.SierraLeone"), flag: "🇸🇱", code: "SL" },
    { name: () => t("Countries.Singapore"), flag: "🇸🇬", code: "SG" },
    { name: () => t("Countries.SintMaarten"), flag: "🇸🇽", code: "SX" },
    { name: () => t("Countries.Slovakia"), flag: "🇸🇰", code: "SK" },
    { name: () => t("Countries.Slovenia"), flag: "🇸🇮", code: "SI" },
    { name: () => t("Countries.SolomonIslands"), flag: "🇸🇧", code: "SB" },
    { name: () => t("Countries.Somalia"), flag: "🇸🇴", code: "SO" },
    { name: () => t("Countries.SouthAfrica"), flag: "🇿🇦", code: "ZA" },
    { name: () => t("Countries.SouthGeorgia"), flag: "🇬🇸", code: "GS" },
    { name: () => t("Countries.SouthSudan"), flag: "🇸🇸", code: "SS" },
    { name: () => t("Countries.Spain"), flag: "🇪🇸", code: "ES" },
    { name: () => t("Countries.SriLanka"), flag: "🇱🇰", code: "LK" },
    { name: () => t("Countries.Sudan"), flag: "🇸🇩", code: "SD" },
    { name: () => t("Countries.Suriname"), flag: "🇸🇷", code: "SR" },
    { name: () => t("Countries.Svalbard"), flag: "🇸🇯", code: "SJ" },
    { name: () => t("Countries.Eswatini"), flag: "🇸🇿", code: "SZ" },
    { name: () => t("Countries.Sweden"), flag: "🇸🇪", code: "SE" },
    { name: () => t("Countries.Switzerland"), flag: "🇨🇭", code: "CH" },
    { name: () => t("Countries.Syrian"), flag: "🇸🇾", code: "SY" },
    { name: () => t("Countries.Taiwan"), flag: "🇹🇼", code: "TW" },
    { name: () => "TAIWAN, PROVINCE DE CHINE", flag: "🇹🇼", code: "TW", silent: true },
    { name: () => t("Countries.Tajikistan"), flag: "🇹🇯", code: "TJ" },
    { name: () => t("Countries.Tanzania"), flag: "🇹🇿", code: "TZ" },
    { name: () => t("Countries.Thailand"), flag: "🇹🇭", code: "TH" },
    { name: () => t("Countries.Timor-Leste"), flag: "🇹🇱", code: "TL" },
    { name: () => t("Countries.Togo"), flag: "🇹🇬", code: "TG" },
    { name: () => t("Countries.Tokelau"), flag: "🇹🇰", code: "TK" },
    { name: () => t("Countries.Tonga"), flag: "🇹🇴", code: "TO" },
    { name: () => t("Countries.Trinidad"), flag: "🇹🇹", code: "TT" },
    { name: () => t("Countries.Tunisia"), flag: "🇹🇳", code: "TN" },
    { name: () => t("Countries.Türkiye"), flag: "🇹🇷", code: "TR" },
    { name: () => t("Countries.Turkmenistan"), flag: "🇹🇲", code: "TM" },
    { name: () => t("Countries.TurksCaicos"), flag: "🇹🇨", code: "TC" },
    { name: () => t("Countries.Tuvalu"), flag: "🇹🇻", code: "TV" },
    { name: () => t("Countries.Uganda"), flag: "🇺🇬", code: "UG" },
    { name: () => t("Countries.Gabon"), flag: "🇬🇦", code: "GA" },
    { name: () => t("Countries.Ukraine"), flag: "🇺🇦", code: "UA" },
    { name: () => t("Countries.UnitedArabEmirates"), flag: "🇦🇪", code: "AE" },
    { name: () => t("Countries.UnitedKingdom"), flag: "🇬🇧", code: "GB" },
    { name: () => "GRANDE-BRETAGNE", flag: "🇬🇧", code: "GB", silent: true },
    { name: () => t("Countries.UnitedStates"), flag: "🇺🇸", code: "US" },
    { name: () => "USA", flag: "🇺🇸", code: "US", silent: true }, // R&W smooth experience
    { name: () => t("Countries.Uruguay"), flag: "🇺🇾", code: "UY" },
    { name: () => t("Countries.Uzbekistan"), flag: "🇺🇿", code: "UZ" },
    { name: () => t("Countries.Vanuatu"), flag: "🇻🇺", code: "VU" },
    { name: () => t("Countries.Venezuela"), flag: "🇻🇪", code: "VE" },
    { name: () => t("Countries.VietNam"), flag: "🇻🇳", code: "VN" },
    { name: () => "VIETNAM", flag: "🇻🇳", code: "VN", silent: true },
    { name: () => t("Countries.WallisFutuna"), flag: "🇼🇫", code: "WF" },
    { name: () => t("Countries.Yemen"), flag: "🇾🇪", code: "YE" },
    { name: () => t("Countries.Zambia"), flag: "🇿🇲", code: "ZM" },
    { name: () => t("Countries.Zimbabwe"), flag: "🇿🇼", code: "ZW" },
] as const;

export const getCountries = (): TCountries[] => {
    return countries.map((country) => ({ ...country, name: country.name() }));
};

/** Country of a stored code, whatever its case (`fr` and `FR` are the same country). */
export const findCountry = (countries: TCountries[], code: string) =>
    countries.find((country) => country.code.toLowerCase() === code.trim().toLowerCase());
